import {TextField, useTheme, Box} from "@mui/material";
import {useState} from "react";
import useMediaQuery from "@mui/material/useMediaQuery/useMediaQuery";
import styles from "../styles/Providers.module.css"

export default function SubdomainInput({channelDomain, input, performAction, placeholder}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [value, setValue] = useState({ input: ''});

  const handleChange = (event) => {
    const value = event.target.value;
    setValue(value);
    performAction(value);
  };

  return(
      <Box className={isMobile ? styles.formSectionMobile : styles.formSection} {...input}>
        <Box className={isMobile ? styles.descriptionMobile : styles.description}>
          https://
        </Box>
        <Box className={styles.subdomainTextFieldWrapper}>
          <TextField
              className={styles.subdomainTextField}
              InputProps={{ classes: { root: styles.subdomainTextField } }}
              label={placeholder}
              onChange={handleChange}
              variant="outlined"
          />
        </Box>
        <Box className={isMobile ? styles.descriptionMobile : styles.description}>
          {channelDomain}
        </Box>
      </Box>
  )
}
